import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import '../styles/reset-password.css';

const API_BASE = process.env.REACT_APP_API_URL || '';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    if (!token) {
      setMessage({ text: 'Token no encontrado en la URL', type: 'error' });
    }
  }, [token]);

  function showMessage(text, type = 'success') {
    setMessage({ text, type });
    setTimeout(() => setMessage(null), 4000);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!token) {
      showMessage('Token inválido', 'error');
      return;
    }
    if (!password || password.length < 6) {
      showMessage('La contraseña debe tener al menos 6 caracteres', 'error');
      return;
    }
    if (password !== confirm) {
      showMessage('Las contraseñas no coinciden', 'error');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/recover/reset`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password })
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok) {
        showMessage(data.message || 'Contraseña restablecida correctamente', 'success');
        setTimeout(() => navigate('/login'), 1500);
      } else {
        showMessage(data.error || 'Error al restablecer la contraseña', 'error');
      }
    } catch (err) {
      console.error('Error en /recover/reset', err);
      showMessage('Error de red', 'error');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="recovery-wrapper">
      <div className="recovery-container">
        <div className="logo-container">
          <a href="/" aria-label="Ir a inicio">
            <img src="/logo512.png" alt="Ker Logo" className="logo-icon" />
          </a>
        </div>

        {message && <div className={`message ${message.type}`} style={{ display: 'block' }}>{message.text}</div>}

        <div className="form-container active">
          <div className="icon-container"><div className="recovery-icon">🔑</div></div>
          <div className="recovery-header">
            <h1 className="recovery-title">Restablecer contraseña</h1>
            <p className="recovery-subtitle">Crea una nueva contraseña para tu cuenta</p>
          </div>

          <form id="reset-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="password">Nueva contraseña</label>
              <div className="input-wrapper">
                <input type="password" id="password" name="password" placeholder="Nueva contraseña" value={password} onChange={e => setPassword(e.target.value)} required />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="confirm">Confirmar contraseña</label>
              <div className="input-wrapper">
                <input type="password" id="confirm" name="confirm" placeholder="Repite la contraseña" value={confirm} onChange={e => setConfirm(e.target.value)} required />
              </div>
            </div>

            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? 'Restableciendo...' : 'Restablecer contraseña'}
            </button>
          </form>

        </div>
      </div>
    </div>
  );
}
